import React from 'react'
import styles from './title.module.scss'

interface TitleProps {
  title: string
  onClickHandler: () => void
  selected: any
}

const Title = ({ title, onClickHandler, selected }: TitleProps) => {
  return (
    <div className={styles.container}>
      <div
        onClick={() => onClickHandler()}
        className={`${styles.title} ${selected && styles.selected}`}
      >
        {title}
      </div>
      {selected && <div className={styles.triangle}></div>}
    </div>
  )
}

export default Title
